/* Cancello delle rotte protette. Tutto il backend tranne il login richiede un
 * JWT: senza sessione non ha senso montare una schermata che riceverà solo 401.
 * Si ricorda da dove si arrivava, così dopo il rientro non si finisce sempre
 * sulla home. */

import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { usaAccesso } from './ContestoAccesso';

export function RichiedeAccesso({ children }: { children: ReactNode }) {
  const { autenticato } = usaAccesso();
  const posizione = useLocation();

  if (!autenticato) {
    return <Navigate to="/accesso" replace state={{ da: posizione.pathname + posizione.search }} />;
  }
  return <>{children}</>;
}
